import { Component, type ReactNode } from 'react';

/**
 * Keeps one lazy homepage section from taking the whole page down (2026-10-14):
 * if its file fails to load (weak mobile data) or it throws, the section is
 * simply left out and the rest of the page keeps working.
 */
export default class SafeSection extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    console.error('Section left out:', error);
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
